enum AddressTypeEnum {
  BILLING = "BILLING",
  HOME = "HOME",
  SHIPPING = "SHIPPING",
  VISITING = "VISITING",
}

export default AddressTypeEnum;
